import { TAlign } from '../models'

export const getAlignMods = (styles: Record<string, string>, align?: TAlign) => {
  return {
    [styles.end]: align === 'end',
  }
}
